import { ActionType, NetworkActionPrefix, UserNotificationEventSource } from '../utils/constants';
import defaults from '../api/defaults';
import { deepAssign } from '../utils';
import { combineReducers, pipeReducers, networkPaginationLoadReducer, networkActionReducer, synchronizableEnumReducer, networkObjectLoadReducer, networkEntityEditReducer } from '../utils/reducerFactory';

export default combineReducers({
    userNotificationEventSources: synchronizableEnumReducer(NetworkActionPrefix.LOAD_USER_NOTIFICATION_EVENT_SOURCES_PREFIX, defaults.NetworkArray, UserNotificationEventSource, 'UserNotificationEventSource'),
    userNotificationUserSettings: pipeReducers(
        networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_USER_NOTIFICATION_USER_SETTINGS_PREFIX, defaults.NetworkArray),
        networkEntityEditReducer(
            NetworkActionPrefix.UPDATE_ALL_USER_NOTIFICATION_USER_SETTINGS_PREFIX, defaults.NetworkArray,
            (state, action) => deepAssign(state, { Data: state.Data.filter(({ UserID }) => UserID != action.userID).concat(action.response) }),
            true
        )
    )
});